interface HowDoesVerifyingWorkMessagesInterface {
    docUploadStudent: string;
    defaultStudent: string;
    docUploadTeacher: string;
    defaultTeacher: string;
    docUploadMilitary: string;
    defaultMilitary: string;
    docUploadSenior: string;
    defaultSenior: string;
    docUploadFirstResponder: string;
    defaultFirstResponder: string;
    docUploadMedical: string;
    defaultMedical: string;
}

export function howDoesVerifyingWorkMessages(): HowDoesVerifyingWorkMessagesInterface {
    return {
        docUploadStudent: `Document review is handled by SheerID, a trusted partner who specializes in verifying students.<br><br>
                    Documents are used only for verifying your student status is current and will be permanently deleted after
                    review is finalized. They will not be shared with {companyName}.`,

        defaultStudent: `To be eligible for this offer, you must currently be enrolled in a degree-granting, accredited school of higher
                    education.<br><br>{companyName} uses SheerID, a trusted partner, to verify that you are a current student.
                    SheerID only collects information that assists in verifying your eligibility. Additional information or documentation
                    may be requested.`,

        docUploadTeacher: `Document review is handled by SheerID, a trusted partner who specializes in verifying teachers.<br><br>
                    Documents are used only for verifying your teacher or faculty status is current and will be permanently
                    deleted after review is finalized. They will not be shared with {companyName}.`,

        defaultTeacher: `To be eligible for this offer, you must currently be employed as a teacher, faculty or staff at a K-12
                    school or university in the United States.<br><br> {companyName} uses SheerID, a trusted partner,
                    to verify that you are a current teacher, faculty or staff member. SheerID only collects information that
                    assists in verifying your eligibility. Additional information or documentation may be requested.`,

        docUploadMilitary: `Document review is handled by SheerID, a trusted partner who specializes in verifying military.<br><br>
                    Documents are used only for verifying your military status is current and will be permanently deleted
                    after review is finalized. They will not be shared with {companyName}.`,

        defaultMilitary: `This offer is available to military personnel who have served or are currently serving in the United
                    States Armed Forces.<br><br> {companyName} uses SheerID, a trusted partner, to verify that you are a
                    member of the military. SheerID only collects information that assists in verifying your eligibility.
                    Additional information or documentation may be requested.`,

        docUploadSenior: `Document review is handled by SheerID, a trusted partner who specializes in verifying age..<br><br>
                    Documents are used only for verifying your current age and will be permanently deleted
                    after review is finalized. They will not be shared with {companyName}.`,

        defaultSenior: `To be eligible for this offer, you must be of a certain age.<br><br> {companyName} uses SheerID, a
                    trusted partner, to verify your age. SheerID only collects information that assists in verifying your
                    eligibility. Additional information or documentation may be requested.`,

        docUploadFirstResponder: `Document review is handled by SheerID, a trusted partner who specializes in verifying first
                    responders.<br><br>Documents are used only for verifying your first responder status is current and will be permanently
                    deleted after review is finalized. They will not be shared with {companyName}`,

        defaultFirstResponder: `This offer is available to all US first responders and emergency personnel - including law
                    enforcement, EMTs, paramedics, and firefighters.<br><br>{companyName} uses SheerID, a trusted partner, to verify
                    that you are an active first responder. SheerID only collects information that assists in verifying your eligibility.
                    Additional information or documentation may be requested.`,

        docUploadMedical: `Document review is handled by SheerID, a trusted partner who specializes in verifying medical professionals.<br><br>
                    Documents are used only for verifying your medical professional status is current and will be permanently deleted after review 
                    is finalized. They will not be shared with {companyName}.`,

        defaultMedical: `To be eligible for this offer, you must (1) be a medical professional currently licensed in the United States and (2) be a 
                    member of an eligible branch of the medical profession. Eligible branches are shown in the Status selector of this form.<br><br>
                    {company} uses SheerID, a trusted partner, to verify that you are a medical professional. SheerID only collects information that 
                    assists in verifying your eligibility. Additional information or documentation may be requested.`,
    };
}
